import createReactComponent from '../createReactComponent';
export default createReactComponent('male', 'Male', [["path",{"d":"M14.232 9.747a6 6 0 1 0-8.465 8.506 6 6 0 0 0 8.465-8.506m0 0L20 4m0 0h-4m4 0v4","key":"svg-0"}]]);